import type { BuildingTypeId } from '../sim/buildings/definitions';
import type { UnitTypeId } from '../sim/units/unitDefs';

/**
 * Cosmetic colony skins from the Season Pass (D122): pure tints on the local
 * player's own art — no gameplay effect, nothing shown to change for others.
 */
export interface SkinTint {
  readonly building?: number;
  readonly unit?: number;
  /** Only these types are tinted (omitted: all). */
  readonly buildings?: readonly BuildingTypeId[];
  readonly units?: readonly UnitTypeId[];
}

export const SKIN_TINTS: Readonly<Record<string, SkinTint>> = {
  rust: { building: 0xe6b48f },
  night: { building: 0x9fb1dc, unit: 0xa8b8e0 },
  gold: { building: 0xffd56e, buildings: ['command_center'] },
  ember: { unit: 0xffa262, units: ['flamer'] },
  ashfall: { building: 0xcfc6ba, unit: 0xd8d0c4 },
};

export function buildingTint(skin: string | null, type: BuildingTypeId): number | null {
  const s = skin ? SKIN_TINTS[skin] : undefined;
  if (!s?.building || (s.buildings && !s.buildings.includes(type))) return null;
  return s.building;
}

export function unitTint(skin: string | null, type: UnitTypeId): number | null {
  const s = skin ? SKIN_TINTS[skin] : undefined;
  if (!s?.unit || (s.units && !s.units.includes(type))) return null;
  return s.unit;
}
